window.PXUTheme = window.PXUTheme || {};

window.PXUTheme.jsFeaturedPromos = {
  init: function ($section) {
    $section.find('[data-featured-promotions-slider]').each(function () {

      const $promoSlider = $(this);
      const el = this;

      const $sectionRoot = $promoSlider.closest('#shopify-section-' + el.dataset.sectionId);
      const $prevButton = $sectionRoot.find('.featured-promotions__nav--prev');
      const $nextButton = $sectionRoot.find('.featured-promotions__nav--next');

      let flkty = null;
      let currentMode = null; // track mobile vs desktop

      function initSlider(isMobile) {

        const swipeableSetting = el.dataset.swipeable === 'true';

        const swipeable = isMobile ? true : swipeableSetting;
        const autoPlay = isMobile ? 7000 : (swipeableSetting ? 7000 : false);

        flkty = $promoSlider.flickity({
          initialIndex: 0,
          contain: true,
          wrapAround: true,
          cellSpacing: 20,
          cellAlign: 'left',
          prevNextButtons: false,
          pageDots: false,
          imagesLoaded: true,
          draggable: swipeable,
          autoPlay: autoPlay
        }).data('flickity');

        flkty.on('ready', function () {
          flkty.resize();
        });

        $prevButton.off('click.promoNav').on('click.promoNav', () => flkty.previous());
        $nextButton.off('click.promoNav').on('click.promoNav', () => flkty.next());

        $promoSlider.data('flickityInstance', flkty);
      }

      function destroySlider() {
        if (flkty) {
          flkty.destroy();
          flkty = null;
        }
      }

      function checkBreakpoint() {
        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (currentMode !== isMobile) {
          currentMode = isMobile;
          destroySlider();
          initSlider(isMobile);
        }
      }

      // Initial load
      checkBreakpoint();

      // Listen for breakpoint crossing
      window.addEventListener('resize', checkBreakpoint);
    });
  }
};